import { Component, OnInit } from '@angular/core';

import {
  AuthenticationService, 
  ContactApiService,
  CrossSiteNavigationService
} from '../data-services/index';

import {
  IContact, IUser, IHelp, HelpApiService, AppLoadService
} from '@ebb-v2/ebb-integration';
import { Router } from '@angular/router';

@Component({
    selector: 'ebb-portal-material',
    templateUrl: './material.component.html',
    styles: [],
    standalone: false
})
export class MaterialComponent implements OnInit {
  public currentUser: IUser;
  public currentContact: IContact;
  public listHelp: IHelp[] = [];

  public textContractorMaterialEbbComplete: string;
  public textContractorMaterialEbbIncomplete: string;
  public textContractorMaterialEssComplete: string;
  public textContractorMaterialEssIncomplete: string;
  public textContractorMaterialEmrComplete: string;
  public textContractorMaterialEmrIncomplete: string;
  public ebbTrainingUrl: string;
  public essTrainingUrl: string;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly apiContact: ContactApiService,
    private readonly xSiteNavigationService: CrossSiteNavigationService,
    private readonly apiAppSettings: AppLoadService,
    private apiHelp: HelpApiService,
    private router: Router
  ) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getContact(this.currentUser.id);

    this.ebbTrainingUrl = this.xSiteNavigationService.ebbSiteUrl(
      '/Contractors-Design-Professionals/FEMA-Education-Course', this.currentUser
    );
    this.essTrainingUrl = this.xSiteNavigationService.essSiteUrl(
      '/Contractors-Design-Professionals/FEMA-Education-Course', this.currentUser
    );
    this.loadHelpText();
  }

  private getContact(currentId: string): void {
    this.apiContact
      .getContact(currentId)
      .subscribe(
        data => {
         this.currentContact = data;
        },
        error => console.warn(`ERROR: ContractorMaterials.getContact() - ${error}`)
      )
  }
  public redirectToESSTraining() {
    this.router.navigate(['/trainingess']);
  }
  public redirectToEMRTraining() {
    this.router.navigate(['/trainingemr']);
  }
  public  redirectToEBBTraining() {
    this.router.navigate(['/trainingebb']);
  }
  private loadHelpText(): void {
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = [...data];

          const indexContractorMaterialEssComplete = this.listHelp
            .findIndex(i => i.name.toLowerCase() === 'contractormaterialsesscomplete');
            if (indexContractorMaterialEssComplete >= 0)          
              this.textContractorMaterialEssComplete  = this.listHelp[indexContractorMaterialEssComplete].answer;

          const indexContractorMaterialEbbComplete = this.listHelp
            .findIndex(i => i.name.toLowerCase() === 'contractormaterialsebbcomplete');
            if (indexContractorMaterialEbbComplete >= 0)          
              this.textContractorMaterialEbbComplete = this.listHelp[indexContractorMaterialEbbComplete].answer;

          const indexContractorMaterialEssIncomplete = this.listHelp
              .findIndex(i => i.name.toLowerCase() === 'contractormaterialsessincomplete');
            if (indexContractorMaterialEssIncomplete >= 0)
              this.textContractorMaterialEssIncomplete = this.listHelp[indexContractorMaterialEssIncomplete].answer;
          
          const indexContractorMaterialEbbIncomplete = this.listHelp
            .findIndex(i => i.name.toLowerCase() === 'contractormaterialsebbincomplete');
          if (indexContractorMaterialEbbIncomplete >= 0)
            this.textContractorMaterialEbbIncomplete = this.listHelp[indexContractorMaterialEbbIncomplete].answer;
          const indexContractorMaterialEmrIncomplete = this.listHelp
          .findIndex(i => i.name.toLowerCase() === 'contractormaterialsemrincomplete');
        if (indexContractorMaterialEmrIncomplete >= 0)
          this.textContractorMaterialEmrIncomplete = this.listHelp[indexContractorMaterialEmrIncomplete].answer;
      
      const indexContractorMaterialEmrComplete = this.listHelp
        .findIndex(i => i.name.toLowerCase() === 'contractormaterialsemrcomplete');
      if (indexContractorMaterialEmrComplete >= 0)
        this.textContractorMaterialEmrComplete = this.listHelp[indexContractorMaterialEmrComplete].answer;
        },
        error => console.log(error)
      );
  }

}
